import {
  GeneralInvestmentDTO,
  GeneralInvestmentRequestDTO,
  GeneralInvestmentReportDTO,
  PDFGralInvestRow,
} from './../models/control-panel.model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import moment, { Moment } from 'moment';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { ExcelService } from '@app/@shared/services/print/excel.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { dataPrint } from '@app/requests/model/requests-model';
import { jsPDF } from 'jspdf';
import autoTable, { Table } from 'jspdf-autotable';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { TransformNumberPipe } from '@app/@shared/pipes/transform-number.pipe';
import FileSaver from 'file-saver';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { Credentials } from '@app/@core/models/login-models';
import {
  BUSINESS_DIRECTOR,
  CHAIN,
  MACRO_CHAIN,
  MACRO_OFFICE,
  OFFICE_DIRECTOR,
} from '@app/@core/constants/users.constants';

const FORM_PARAM_MACRO_CHAIN = 'macroChain';
const FORM_PARAM_MACRO_OFFICE = 'macroOffice';

const emptyCommonDataDTO: CommonDataDTO = {
  id: undefined,
  value: '',
};
import { TranslateService } from '@ngx-translate/core';
import { DatepickerUtilsService } from '@app/@shared/services/utils/datepicker-utils.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DATE_FORMAT_MMMM_YYYY, LOCALE_CA, LOCALE_ES } from '@app/@core/constants/common.constants';
import { ControlPanelStore } from '../control-panel-service/control-panel.store';

@UntilDestroy()
@Component({
  selector: 'app-general-of-investment',
  templateUrl: './general-of-investment.component.html',
  styleUrls: ['./general-of-investment.component.scss'],
})
export class GeneralOfInvestmentComponent implements OnInit {
  gralOfInvestmentForm: FormGroup;
  investmentData: GeneralInvestmentReportDTO;
  divisionList: CommonDataDTO[] = [];
  officeList: CommonDataDTO[];
  productList: CommonDataDTO[];
  articleList: CommonDataDTO[];
  originList: CommonDataDTO[];
  totalsList: GeneralInvestmentDTO[];
  consultDisabled: boolean = true;
  noOperations: boolean = false;
  searchParamsExcel: string[];
  macroChainList: CommonDataDTO[] = [];
  macroOfficeList: CommonDataDTO[] = [];

  isMacroChainUser: boolean = false;
  isMacroOfficeUser: boolean = false;
  isBusinessDirector: boolean = false;

  private userInfo: Credentials;

  public maxFinalDate: Date = new Date();
  public currentDate: Date = new Date();
  public minFinalDate: Date = new Date();
  public minDate: Date = new Date('1/1/1900');

  public allData: any[] = [];
  public head = [
    'generalOfInvestment.calification',
    'generalOfInvestment.numOperations',
    'generalOfInvestment.investment',
    'generalOfInvestment.percentageOverTotal',
    'generalOfInvestment.averagePl',
    'generalOfInvestment.averageTIR',
  ];

  constructor(
    private formBuilder: FormBuilder,
    private excelService: ExcelService,
    private controlPanelSore: ControlPanelStore,
    public dialog: MatDialog,
    private customValidators: CustomValidatorsService,
    private transformNumberPipe: TransformNumberPipe,
    private combosStore: CombosStore,
    private translateService: TranslateService,
    private datepickerUtils: DatepickerUtilsService
  ) {
    let dataString: string = localStorage.getItem('credentials');
    this.userInfo = JSON.parse(dataString);

    this.translateService.onLangChange.subscribe(() => {
      this.updatesearchInvestment();
    });
  }

  ngOnInit() {
    this.gralOfInvestmentForm = this.formBuilder.group(
      {
        division: ['', Validators.required],
        office: [''],
        products: [''],
        article: [''],
        origin: [''],
        startDate: ['', [Validators.required, this.customValidators.checkIsFutureDate]],
        endDate: [{ value: '', disabled: true }, [Validators.required, this.customValidators.checkIsFutureDate]],
      },
      {
        validators: [
          this.customValidators.isDateValid('startDate', 'endDate', 'dateInvalid'),
          this.customValidators.isMoreThanAYearApart('startDate', 'endDate', 'dateYearError'),
        ],
      }
    );

    this.translateService.currentLang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan();
    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe((event) =>
        event.lang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan()
      );

    this.gralOfInvestmentForm.controls.startDate.statusChanges.subscribe((value) => {
      if (value === 'VALID') {
        const initialDateValue = this.gralOfInvestmentForm.controls.startDate.value;
        this.minFinalDate = initialDateValue.toDate();
        this.maxFinalDate = moment(initialDateValue).add(11, 'months').endOf('month').toDate();
        if (this.gralOfInvestmentForm.controls.endDate.disabled) this.gralOfInvestmentForm.controls.endDate.enable();
      } else {
        this.minFinalDate = undefined;
        this.maxFinalDate = this.currentDate;
      }
    });

    this.gralOfInvestmentForm.statusChanges.subscribe(() => {
      if (
        this.gralOfInvestmentForm.controls.division.value &&
        this.gralOfInvestmentForm.controls.startDate.value &&
        this.gralOfInvestmentForm.controls.endDate.value &&
        this.gralOfInvestmentForm.valid
      ) {
        this.consultDisabled = false;
      } else {
        this.consultDisabled = true;
      }
    });

    this.gralOfInvestmentForm.controls.startDate.statusChanges.subscribe((value) => {
      if (value === 'VALID' || this.gralOfInvestmentForm.controls.startDate.value) {
        const initialDateValue = this.gralOfInvestmentForm.controls.startDate.value;
        this.minDate = initialDateValue.toDate();
        this.maxFinalDate = moment(initialDateValue).add(12, 'months').endOf('month').toDate();
      } else {
        this.minDate = undefined;
        this.maxFinalDate = this.currentDate;
      }
    });

    this.validateMacroChainUser();
    if (this.isBusinessDirector) this.initMacroUsers([FORM_PARAM_MACRO_CHAIN, FORM_PARAM_MACRO_OFFICE]);
    else if (this.isMacroChainUser) this.initMacroUsers([FORM_PARAM_MACRO_CHAIN]);
    else if (this.isMacroOfficeUser) this.initMacroUsers([FORM_PARAM_MACRO_OFFICE]);
    else {
      this.loadDivisionCombo();
      this.loadOffices();
      this.loadProductsCombo();
      this.loadArticlesCombo();
      this.loadOriginCombo();
    }
  }

  getSelectOptionAllName(): string {
    return this.translateService.instant('select.option.all');
  }

  getSelectOptionAllNameFem(): string {
    return this.translateService.instant('select.option.allFem');
  }

  updatesearchInvestment() {
    if (this.allData.length > 0) {
      this.searchParamsExcel = [
        this.gralOfInvestmentForm.controls.office.value
          ? this.officeList.find((office) => office.id === this.gralOfInvestmentForm.controls.office.value)?.value
          : this.getSelectOptionAllNameFem(),
        '',
        this.gralOfInvestmentForm.controls.products.value
          ? this.productList.find((product) => product.id === this.gralOfInvestmentForm.controls.products.value)?.value
          : this.getSelectOptionAllName(),
        this.gralOfInvestmentForm.controls.origin.value
          ? this.originList.find((origin) => origin.id === this.gralOfInvestmentForm.controls.origin.value)?.value
          : this.getSelectOptionAllName(),
        this.gralOfInvestmentForm.controls.article.value
          ? this.articleList.find((article) => article.id === this.gralOfInvestmentForm.controls.article.value)?.value
          : this.getSelectOptionAllName(),
        `${this.divisionList[0]?.id} ${this.divisionList[0]?.value}`,
        'EUROS',
      ];
    }
  }

  searchInvestment() {
    let request: GeneralInvestmentRequestDTO = {
      divisionId: this.gralOfInvestmentForm.controls.division.value,
      articleId: this.gralOfInvestmentForm.controls.article?.value,
      officeId: this.gralOfInvestmentForm.controls.office?.value,
      productId: this.gralOfInvestmentForm.controls.products?.value,
      originId: this.gralOfInvestmentForm.controls.origin?.value,
      fromDate: this.gralOfInvestmentForm.controls.startDate.value.startOf('month').format('YYYY-MM-DD'),
      toDate: this.gralOfInvestmentForm.controls.endDate.value.endOf('month').format('YYYY-MM-DD'),
    };

    //mantener este orden, que es el que hay en el excelservice
    this.searchParamsExcel = [
      this.gralOfInvestmentForm.controls.office.value
        ? this.officeList.find((office) => office.id === this.gralOfInvestmentForm.controls.office.value)?.value
        : this.getSelectOptionAllNameFem(),
      '',
      this.gralOfInvestmentForm.controls.products.value
        ? this.productList.find((product) => product.id === this.gralOfInvestmentForm.controls.products.value)?.value
        : this.getSelectOptionAllName(),
      this.gralOfInvestmentForm.controls.origin.value
        ? this.originList.find((origin) => origin.id === this.gralOfInvestmentForm.controls.origin.value)?.value
        : this.getSelectOptionAllName(),
      this.gralOfInvestmentForm.controls.article.value
        ? this.articleList.find((article) => article.id === this.gralOfInvestmentForm.controls.article.value)?.value
        : this.getSelectOptionAllName(),
      this.divisionList[0]?.id + ' ' + this.divisionList[0]?.value,
      'EUROS',
    ];

    let dialogConfig = new MatDialogConfig();
    this.controlPanelSore.getGeneralInvestment(request).then(
      (data) => {
        this.allData = [];
        if (data && data.items.length > 0) {
          this.investmentData = data;
          //redondeamos el total:
          this.investmentData.total = this.transformNumberPipe.transform(
            Math.round(this.investmentData.total * 100) / 100
          );
          this.totalsList = this.investmentData.items;
          //redondeamos los totales de cada
          this.totalsList.forEach(
            (element) =>
              (element.percentInTotalInversion = this.transformNumberPipe.transform(
                Math.round(element.percentInTotalInversion * 100) / 100
              ))
          );
          //una vez hemos recuperado los datos, los añadimos al allData
          this.totalsList.forEach((element) => this.allData.push(element));
          this.noOperations = false;
        } else {
          this.totalsList = [];
          this.investmentData = { items: [], total: 0 };
          this.noOperations = true;
        }
      },
      (error) => {
        if (
          error.error.status === 406 &&
          error.error.message.includes('greater than 12 months or smaller than 1 month')
        ) {
          dialogConfig.data = {
            text: 'El periodo de búsqueda tiene que ser superior a un mes e inferior a  12 meses',
            icon: 'icon-ic_circle_cross',
            noRedirect: true,
          };
        } else {
          dialogConfig.data = {
            text: 'Error desconocido al recuperar las inversiones',
            icon: 'icon-ic_circle_cross',
            noRedirect: true,
          };
        }
        this.totalsList = [];
        this.investmentData = { items: [], total: 0 };
        this.noOperations = true;
        this.dialog.open(ResponseDialogComponent, dialogConfig);
      }
    );
  }

  createAllExcel() {
    let allDataExcel: dataPrint[] = [];
    allDataExcel = this.allData;
    const filename =
      this.translateService.instant('excel.generalOfInvestment.filename') + moment().locale('es').format('DDMMYYYY');

    this.searchParamsExcel[1] =
      this.getInitialDate(DATE_FORMAT_MMMM_YYYY) + ' a ' + this.getFinalDate(DATE_FORMAT_MMMM_YYYY);

    this.updateHeadersByLanguage();
    const excelAllData = {
      fileName: filename,
      searchData: this.searchParamsExcel,
      totalInvestment: this.investmentData.total,
      data: allDataExcel,
    };
    this.excelService.exporExcelInvestment(excelAllData);
  }

  createAllPdf() {
    new Promise((reject) => {
      try {
        let doc = new jsPDF({
          orientation: 'portrait',
          format: [209.804, 296.926],
        });

        const filename =
          this.translateService.instant('excel.generalOfInvestment.filename') +
          moment().locale('es').format('DDMMYYYY');

        doc.setProperties({
          title: filename,
        });

        /* BODY */
        this.investmentData?.items.forEach((investmentTable) => {
          let dataPdf: any[] = [];

          //table
          let groupTotal = this.generateInvestRow(
            investmentTable.sectorId + ' - ' + investmentTable.serctorDescription,
            investmentTable.numOperations.toString(),
            this.transformNumberPipe.transform(investmentTable.inversion),
            this.transformNumberPipe.transform(investmentTable.totalPortion),
            this.transformNumberPipe.transform(investmentTable.termsAverage),
            this.transformNumberPipe.transform(investmentTable.tirAverage)
          );
          dataPdf.push(groupTotal);

          //footer
          groupTotal = this.generateInvestRow(
            this.translateService.instant('generalOfInvestment.totals'),
            investmentTable.numOperations.toString(),
            this.transformNumberPipe.transform(investmentTable.inversion),
            '',
            this.transformNumberPipe.transform(investmentTable.termsAverage),
            this.transformNumberPipe.transform(investmentTable.tirAverage)
          );
          dataPdf.push(groupTotal);

          doc = this.createPdfTable(
            doc,
            dataPdf,
            this.investmentData.total,
            groupTotal,
            this.translateService.instant('generalOfInvestment.title', {
              description: investmentTable.articleDescription,
              percent: investmentTable.percentInTotalInversion,
            })
          );
        });

        let blob = doc.output('blob');
        FileSaver.saveAs(blob, filename);
        window.open(URL.createObjectURL(blob));
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  }

  createPdfTable(
    doc: jsPDF,
    dataPdf: any,
    totalInvestment: string,
    group?: PDFGralInvestRow,
    tableTitle?: string
  ): jsPDF {
    const lastAutoTable: Table = (doc as any).lastAutoTable;
    const maxTableYCoordinate: number = 260;
    const tableYCoordinateFirstPage: number = 90;
    const tableYCoordinateNotFirstPage: number = 50;
    const distanceTable: number = 10;
    const distanceTypeArticleTable: number = 2;

    //First time
    doc.setFontSize(10);

    let heightLastRow: number = 0;

    let startYTable =
      lastAutoTable?.finalY > (doc.getNumberOfPages() === 1 ? tableYCoordinateFirstPage : tableYCoordinateNotFirstPage)
        ? lastAutoTable.finalY + distanceTable
        : doc.getNumberOfPages() === 1
        ? tableYCoordinateFirstPage
        : tableYCoordinateNotFirstPage;
    if (lastAutoTable.finalY + distanceTable > maxTableYCoordinate) {
      doc.addPage();
      startYTable = doc.getNumberOfPages() === 1 ? tableYCoordinateFirstPage : tableYCoordinateNotFirstPage;
    }
    autoTable(doc, {
      startY: startYTable,
      head: [this.head.map((header) => this.translateService.instant(header))],
      headStyles: { fillColor: '#969696' },
      pageBreak: 'avoid',
      rowPageBreak: 'avoid',
      showHead: 'everyPage',
      margin: { top: tableYCoordinateFirstPage },
      body: dataPdf.map(Object.values),
      styles: { fontSize: 8 },
      didDrawCell: (data) => {
        if (data.row.index === dataPdf.length - 1) {
          heightLastRow = data.row.height;
        }
      },
      didDrawPage: (data) => {
        /* HEADER */
        if (startYTable === tableYCoordinateFirstPage || startYTable === tableYCoordinateNotFirstPage) {
          //TITLE
          const headerXCoordinateES: number = 80;
          const headerXCoordinateCA: number = 65;
          const headerYCoordinate: number = 20;
          doc.setFontSize(24);
          doc.setTextColor('1E90FF');

          const text = this.translateService.instant('excel.dashboard.title');
          if (text.length <= 27) doc.text(text, headerXCoordinateES, headerYCoordinate);
          else doc.text(text, headerXCoordinateCA, headerYCoordinate);

          //IMAGE
          let img = new Image();
          img.src = 'assets/img/logo.PNG';
          doc.addImage(img, 'png', 3, 10, 58, 20);

          //First row
          doc.setTextColor('#000000');
          doc.setFontSize(12);

          const firstRowYCoordinate: number = 35;
          const titleXCoordinate: number = 75;
          doc.text(
            this.translateService.instant('generalOfInvestment.listOfInvestment'),
            titleXCoordinate,
            firstRowYCoordinate
          );
          doc.setFontSize(10);

          const thirdColumnXCoordinate: number = 150;
          doc.text(
            this.translateService.instant('excel.date') + moment().locale('es').format('DD-MM-YYYY HH:mm:ss'),
            thirdColumnXCoordinate,
            firstRowYCoordinate - 3
          );
          doc.text(
            this.translateService.instant('excel.pag') + doc.getNumberOfPages(),
            thirdColumnXCoordinate,
            firstRowYCoordinate + 3
          );

          if (!lastAutoTable) {
            //Only first page
            //Second row
            const secondRowYCoordinate: number = 45;
            const secondRowXCoordinate: number = 12;

            this.searchParamsExcel[1] =
              this.getInitialDate(DATE_FORMAT_MMMM_YYYY) + ' a ' + this.getFinalDate(DATE_FORMAT_MMMM_YYYY);

            this.updateHeadersByLanguage();
            doc.text(
              this.translateService.instant('excel.office') + this.searchParamsExcel[0],
              secondRowXCoordinate,
              secondRowYCoordinate
            );
            doc.text(
              this.translateService.instant('excel.period') + this.searchParamsExcel[1],
              secondRowXCoordinate,
              secondRowYCoordinate + 5
            );
            doc.text(
              this.translateService.instant('excel.product') + this.searchParamsExcel[2],
              secondRowXCoordinate,
              secondRowYCoordinate + 10
            );
            doc.text(
              this.translateService.instant('excel.origin') + this.searchParamsExcel[3],
              secondRowXCoordinate,
              secondRowYCoordinate + 15
            );
            doc.text(
              this.translateService.instant('excel.typeOfGood') + this.searchParamsExcel[4],
              secondRowXCoordinate,
              secondRowYCoordinate + 20
            );
            doc.text(
              this.translateService.instant('excel.division') + this.searchParamsExcel[5],
              secondRowXCoordinate,
              secondRowYCoordinate + 25
            );
            doc.text(
              this.translateService.instant('excel.currency') + this.searchParamsExcel[6],
              secondRowXCoordinate,
              secondRowYCoordinate + 30
            );

            //total inversion
            doc.text(
              this.translateService
                .instant('generalOfInvestment.totalInvestment', { total: totalInvestment })
                ?.toUpperCase(),
              160 - (totalInvestment.length + 17),
              secondRowYCoordinate + 30
            );
          }
        }
      },
    });

    const currentAutoTable: Table = (doc as any).lastAutoTable;
    doc.line(14, currentAutoTable.finalY - heightLastRow, 196, currentAutoTable.finalY - heightLastRow, 'F');
    doc.text(
      tableTitle,
      14,
      startYTable < maxTableYCoordinate
        ? startYTable - distanceTypeArticleTable
        : currentAutoTable.finalY - (startYTable - currentAutoTable.finalY) - distanceTypeArticleTable
    );

    return doc;
  }

  generateInvestRow(
    articleNameSend: string,
    numOperationsSend: string,
    investmentSend: string,
    totalPortionSend: string,
    termsAverageSend: string,
    tirAverageSend: string
  ): PDFGralInvestRow {
    return {
      articleName: articleNameSend,
      numOperations: numOperationsSend,
      investment: investmentSend,
      totalPortion: totalPortionSend,
      termsAverage: termsAverageSend,
      tirAverage: tirAverageSend,
    };
  }

  getPeriod(startDate: Date, endDate: Date): string {
    const meses = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    const sd = new Date(startDate);
    const ed = new Date(endDate);
    return meses[sd.getMonth()] + '-' + sd.getFullYear() + ' hasta ' + meses[ed.getMonth()] + '-' + ed.getFullYear();
  }

  loadOriginCombo() {
    this.controlPanelSore.getListOrigins().then(
      (data) => {
        if (data) {
          this.originList = data.length === 1 ? [...data] : [{ id: undefined, value: '' }, ...data];
          if (this.originList.length === 1) this.gralOfInvestmentForm.controls.origin.setValue(this.originList[0].id);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  loadArticlesCombo(filter?: any) {
    this.controlPanelSore
      .getListArticles(filter)
      .then(
        (data) => {
          if (data) {
            this.articleList = data.length === 1 ? [...data] : [{ id: undefined, value: '' }, ...data];
            if (this.articleList.length === 1)
              this.gralOfInvestmentForm.controls.article.setValue(this.articleList[0].id);
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  }

  loadProductsCombo(filter?: any) {
    this.controlPanelSore
      .getListProducts(filter)
      .then(
        (data) => {
          if (data) {
            this.productList = data.length === 1 ? [...data] : [{ id: undefined, value: '' }, ...data];
            if (this.productList.length === 1)
              this.gralOfInvestmentForm.controls.products.setValue(this.productList[0].id);
          }
        },
        (error) => {
          console.error(error);
        }
      )
      .catch((error) => console.error(error));
  }

  private loadOffices = async (filter?: any) => {
    this.combosStore
      .getOffices(filter)
      .then(
        (data) => {
          this.officeList = data.length === 1 ? [...data] : [{ id: undefined, value: '' }, ...data];
          if (this.officeList.length === 1) this.gralOfInvestmentForm.controls.office.setValue(this.officeList[0].id);
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  };

  private loadMacroChains = async () => {
    this.resetCombosExceptMacro();
    this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_CHAIN].setValue('');
    this.macroChainList = [];
    const promise = this.isBusinessDirector
      ? this.combosStore.getChainsByDivision(this.userInfo.division?.toString())
      : this.combosStore.getChainsFromMacroUser(this.userInfo.userId);
    promise
      .then(
        (data) => {
          if (data) {
            this.macroChainList =
              this.isBusinessDirector && data.length > 0 ? [emptyCommonDataDTO, ...data] : [...data];
            if (this.macroChainList.length === 1)
              this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_CHAIN].setValue(this.macroChainList[0]?.id);
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  };

  private loadMacroOffices = async () => {
    this.resetCombosExceptMacro();
    this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_OFFICE].setValue('');
    this.macroOfficeList = [];
    const promise = this.isBusinessDirector
      ? this.combosStore.getOfficesByDivision(this.userInfo.division?.toString())
      : this.combosStore.getOfficesFromMacroUser(this.userInfo.userId);
    promise
      .then(
        (data) => {
          if (data) {
            this.macroOfficeList =
              this.isBusinessDirector && data.length > 0 ? [emptyCommonDataDTO, ...data] : [...data];
            if (this.macroOfficeList.length === 1)
              this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_OFFICE].setValue(this.macroOfficeList[0]?.id);
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  };

  loadDivisionCombo() {
    this.combosStore.getDivisions().then(
      (data) => {
        if (data) {
          this.divisionList = [...data];
          if (this.divisionList.length === 1)
            this.gralOfInvestmentForm.controls.division.setValue(this.divisionList[0].id);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  chosenYearHandler(normalizedYear: Moment, controlName: string) {
    const ctrlValue = this.gralOfInvestmentForm.get(controlName).value;
    if (ctrlValue) {
      ctrlValue.year(normalizedYear.year());
      this.gralOfInvestmentForm.get(controlName).setValue(ctrlValue);
    } else {
      this.gralOfInvestmentForm
        .get(controlName)
        .setValue(moment('1/1/' + normalizedYear.year().toString(), 'DD-MM-YYYY'));
    }
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>, controlName: string) {
    const control = this.gralOfInvestmentForm.get(controlName);
    const ctrlValue = control.value;
    if (control.pristine) control.markAsDirty();
    if (ctrlValue) {
      ctrlValue.month(normalizedMonth.month());
      this.gralOfInvestmentForm.get(controlName).setValue(ctrlValue);
    } else {
      this.gralOfInvestmentForm
        .get(controlName)
        .setValue(
          moment(
            '1/' + (normalizedMonth.month() + 1).toString() + '/' + normalizedMonth.year().toString(),
            'DD-MM-YYYY'
          )
        );
    }
    datepicker.close();
  }

  hasAnyOperation() {
    if (this.investmentData) {
      return this.investmentData.items.length > 0;
    }
  }

  private buildRequest = () => {
    let request;
    if (this.isBusinessDirector) {
      request = this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_CHAIN].value
        ? { chainId: this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_CHAIN].value, userType: CHAIN }
        : { officeId: this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_OFFICE].value, userType: OFFICE_DIRECTOR };
    } else if (this.isMacroChainUser)
      request = { chainId: this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_CHAIN].value, userType: CHAIN };
    else if (this.isMacroOfficeUser)
      request = {
        officeId: this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_OFFICE].value,
        userType: OFFICE_DIRECTOR,
      };
    else request = {};
    return request;
  };

  private buildRequestArticleProduct = () => {
    let request;
    if (this.isBusinessDirector) {
      request = this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_CHAIN].value
        ? { codChain: this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_CHAIN].value, typeUser: CHAIN }
        : { officeFk: this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_OFFICE].value, typeUser: OFFICE_DIRECTOR };
    } else if (this.isMacroChainUser)
      request = { codChain: this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_CHAIN].value, typeUser: CHAIN };
    else if (this.isMacroOfficeUser)
      request = {
        officeFk: this.gralOfInvestmentForm.controls[FORM_PARAM_MACRO_OFFICE].value,
        typeUser: OFFICE_DIRECTOR,
      };
    else request = {};
    return request;
  };

  private validateMacroChainUser = () => {
    this.isMacroChainUser = this.userInfo.userType === MACRO_CHAIN;
    this.isMacroOfficeUser = this.userInfo.userType === MACRO_OFFICE;
    this.isBusinessDirector = this.userInfo.userType === BUSINESS_DIRECTOR;
  };

  private initMacroUsers = (formProperties: string[]) => {
    this.disableFormControls();
    formProperties.forEach((property) => {
      this.gralOfInvestmentForm.addControl(property, new FormControl('', Validators.required));
      this.initValueChangesMacroUser(property);
      if (property === FORM_PARAM_MACRO_CHAIN) this.loadMacroChains();
      else if (property === FORM_PARAM_MACRO_OFFICE) this.loadMacroOffices();
    });
  };

  private initValueChangesMacroUser = (property: string) => {
    this.gralOfInvestmentForm.controls[property].valueChanges.subscribe((value) => {
      if (value) {
        const request = this.buildRequest();
        const requestProductsArticles = this.buildRequestArticleProduct();
        this.loadOffices(request);
        this.loadDivisionCombo();
        this.loadProductsCombo(requestProductsArticles);
        this.loadArticlesCombo(requestProductsArticles);
        this.loadOriginCombo();
        if (this.isBusinessDirector)
          this.disableFormControl(
            property === FORM_PARAM_MACRO_CHAIN ? FORM_PARAM_MACRO_OFFICE : FORM_PARAM_MACRO_CHAIN
          );
        this.enableFormControls();
      } else {
        if (this.isBusinessDirector)
          this.enableFormControl(
            property === FORM_PARAM_MACRO_CHAIN ? FORM_PARAM_MACRO_OFFICE : FORM_PARAM_MACRO_CHAIN
          );
        this.disableFormControls();
      }
    });
  };

  private resetCombosExceptMacro = () => {
    this.divisionList = [];
    this.officeList = [];
    this.productList = [];
    this.articleList = [];
    this.originList = [];
    Object.keys(this.gralOfInvestmentForm.controls).forEach((key) =>
      key !== FORM_PARAM_MACRO_CHAIN && key !== FORM_PARAM_MACRO_OFFICE
        ? this.gralOfInvestmentForm.controls[key].setValue('')
        : null
    );
  };

  private disableFormControls = () => {
    if (this.gralOfInvestmentForm) {
      Object.keys(this.gralOfInvestmentForm.controls).forEach((key) => {
        if (key !== FORM_PARAM_MACRO_CHAIN && key !== FORM_PARAM_MACRO_OFFICE) {
          this.gralOfInvestmentForm.controls[key].setValue('');
          if (this.gralOfInvestmentForm.controls[key].enabled) {
            this.gralOfInvestmentForm.controls[key].disable();
          }
        }
      });
    }
  };

  private enableFormControls = () => {
    if (this.gralOfInvestmentForm) {
      Object.keys(this.gralOfInvestmentForm.controls).forEach((key) => {
        if (
          key !== FORM_PARAM_MACRO_CHAIN &&
          key !== FORM_PARAM_MACRO_OFFICE &&
          key !== 'endDate' &&
          this.gralOfInvestmentForm.controls[key].disabled
        ) {
          this.gralOfInvestmentForm.controls[key].enable();
        }
      });
    }
  };

  private enableFormControl = (param: string) => {
    if (param) {
      const form = this.gralOfInvestmentForm.controls;
      if (form[param]?.disabled) form[param].enable();
    }
  };

  private disableFormControl = (param: string) => {
    if (param) {
      const form = this.gralOfInvestmentForm.controls;
      if (form[param]?.enabled) {
        if (form[param].value) form[param].setValue('');
        form[param].disable();
      }
    }
  };
  private getInitialDate(format: string) {
    return this.gralOfInvestmentForm
      ?.get('startDate')
      ?.value?.locale(this.translateService.currentLang === LOCALE_ES ? LOCALE_ES : LOCALE_CA)
      .format(format);
  }

  private getFinalDate(format: string) {
    return this.gralOfInvestmentForm
      ?.get('endDate')
      ?.value?.locale(this.translateService.currentLang === LOCALE_ES ? LOCALE_ES : LOCALE_CA)
      .format(format);
  }

  private updateHeadersByLanguage() {
    if (this.searchParamsExcel) {
      if (this.searchParamsExcel[0].toUpperCase() === 'TODAS' || this.searchParamsExcel[0].toUpperCase() === 'TOTES') {
        this.searchParamsExcel[0] = this.translateService.instant('excel.allIdsFem');
      }
      //this.searchParamsExcel[1] no se traduce ya que es el período con las fechas, se setea en createAllExcel y createPdfTable
      if (this.searchParamsExcel[2].toUpperCase() === 'TODOS' || this.searchParamsExcel[2].toUpperCase() === 'TOTS') {
        this.searchParamsExcel[2] = this.translateService.instant('excel.allIds');
      }
      if (this.searchParamsExcel[3].toUpperCase() === 'TODOS' || this.searchParamsExcel[3].toUpperCase() === 'TOTS') {
        this.searchParamsExcel[3] = this.translateService.instant('excel.allIds');
      }
      if (this.searchParamsExcel[4].toUpperCase() === 'TODOS' || this.searchParamsExcel[4].toUpperCase() === 'TOTS') {
        this.searchParamsExcel[4] = this.translateService.instant('excel.allIds');
      }
    }
  }
}
